export function showDateFR(params) {
  const date = new Date(params);
  return params ? date.toLocaleDateString("fr-FR") : "--/--/----";
}

export function formatPhoneNumber(number) {
  if (!number) return "";
  // number = String(number).slice(0, 13);
  let cleanNumber = number.replace(/\D/g, "");
  const res = cleanNumber.replace(
    /(\d{3})(\d{2})(\d{3})(\d{2})/,
    "$1 $2 $3 $4"
  );
  return res;
}

export function formatCIN(number) {
  if (!number) return "";
  number = String(number).slice(0, 16);
  let cleanNumber = number.replace(/\D/g, "");
  const res = cleanNumber.replace(
    /(\d{3})(\d{3})(\d{3})(\d{3})/,
    "$1 $2 $3 $4"
  );
  return res;
}

export function showFullName(lastName, firstName) {
  const lname = lastName ? lastName.toUpperCase() : "";
  const fname = firstName
    ? firstName
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ")
    : "";
  return `${lname} ${fname}`;
}

export function showMoneyFormat(amount, unit) {
  const montant = Number(amount) || 0;
  return `${montant.toLocaleString("fr-FR", {
    minimumFractionDigits: 0,
  })} ${unit}`;
}

export function isValidURL(url, nullAuthorized = true, allowedDomains = null) {
  if ((!url || url === "") && nullAuthorized) return true;
  try {
    const parsedUrl = new URL(url);
    if (Array.isArray(allowedDomains) && allowedDomains.length > 0) {
      return allowedDomains.some((domain) =>
        parsedUrl.hostname.endsWith(domain)
      );
    }
    return true;
  } catch (e) {
    return false;
  }
}

export function isValidEmail(email, nullAuthorized = true) {
  if ((!email || email === "") && nullAuthorized) return true;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}

export function showDateFR2(params) {
  const date = new Date(params);
  return params ? date.toLocaleDateString("fr-FR") : "--/--/----";
}

export function showNumbreFormat(amount, unit) {
  const montant = Number(amount) || 0;
  return `${montant.toLocaleString("fr-FR", {
    minimumFractionDigits: 0,
  })} ${montant > 1 ? unit  /*+ "s" */ : unit}`;
}

export function formatNumber(amount) {
  const montant = Number(amount) || 0;
  return `${montant.toLocaleString("fr-FR", {
    minimumFractionDigits: 0,
  })}`;
}

export const handleCopy = async (textToCopy) => {
  try {
    await navigator.clipboard.writeText(textToCopy);
    return true;
  } catch (err) {
    return false;
  }
};

export const enleverBaliseHtml = (texte) => {
  if (!texte) return "";
  return texte.replace(/<\/?[^>]+(>|$)/g, "");
};

export const openLink = (link, new_onglet = true) => {
  if (new_onglet) {
    window.open(link, "_blank");
  } else {
    window.open(link);
  }
};

export const isValidPhoneNumber = (phone, nullAuthorized = false) => {
  if ((!phone || phone === "") && nullAuthorized) return true;
  const regex = /^(?:\+261|0)(20|32|33|34|37|38)[0-9]{7}$/;
  return regex.test(phone) && String(phone).length === 10;
};


export const objetDejaDansLeTableau = (obj, tableauSansAttributId) => {
  if (typeof tableauSansAttributId !== "object") throw new Error("Tableau requis");
    return Object.values(tableauSansAttributId).some(item=>item===obj);
};